import { useRef } from 'react';
import { Stack } from 'src/components/Stack';

interface SwipeBoxProps {
  children: React.ReactNode;
  onSwipeLeft: () => void;
  onSwipeRight: () => void;
}

export const SwipeBox = ({
  children,
  onSwipeLeft,
  onSwipeRight,
}: SwipeBoxProps) => {
  const touchStartX = useRef(null);
  const touchEndX = useRef(null);

  const handleTouchStart = (e) => {
    touchStartX.current = e.changedTouches[0].clientX;
  };

  const handleTouchEnd = (e) => {
    touchEndX.current = e.changedTouches[0].clientX;
    handleSwipeGesture();
  };

  const handleSwipeGesture = () => {
    const startX = touchStartX.current ?? 0;
    const endX = touchEndX.current ?? 0;
    const deltaX = endX - startX;
    const threshold = 100; // Minimum distance to count as swipe

    if (Math.abs(deltaX) > threshold) {
      if (deltaX > 0) {
        onSwipeLeft();
      } else {
        onSwipeRight();
      }
    }
  };

  return (
    <Stack
      onTouchStart={handleTouchStart}
      onTouchEnd={handleTouchEnd}
      sx={{
        width: '100%',
        height: '100%',
      }}
    >
      {children}
    </Stack>
  );
};

export default SwipeBox;
